import styled from 'styled-components';

export const EntireContainer = styled.div`
    width: 100%;
`;

// 콘텐츠
export const TitleFrame = styled.div`
    width: 100%;
    padding: 20px;
    background-color: #fff;

    position:fixed;
    top:0;
    left:0;
    z-index:2;
`;

export const ContentFrame = styled.div`
    width: 100%;
    height: 100%;
    margin-top:94.5px;
    overflow-y: auto;
    background-color: #F9F9F9;
`;
